import {
  BLOCKCHAIN,
  CURRENCY,
  FIAT_CODE,
  IFiat,
  IWallet,
  TOKEN_TYPES,
  WALLET_CODE,
  WALLET_TYPE,
} from '@libs/interfaces';

export const FindWalletByCode = (code: WALLET_CODE): IWallet => {
  return Wallets.find(wallet => wallet.code == code);
};
export const FindWalletByCurrency = (currency: CURRENCY): IWallet => {
  return Wallets.find(wallet => wallet.currency == currency);
};
export const Fiat: IFiat[] = [
  {
    code: FIAT_CODE.BRL,
    name: 'Brazilian Real',
    enabled: true,
  },
  {
    code: FIAT_CODE.EUR,
    name: 'Euro',
    enabled: true,
  },
];
export const Wallets: IWallet[] = [
  {
    type: WALLET_TYPE.FIAT,
    code: WALLET_CODE.BRL,
    currency: CURRENCY.BRL,
    name: 'Brazilian real',
    metric: 1,
    decimals: 2,
    enabled: true,
    image: 'assets/wallets/BRL.svg',
    ranges: {
      minWithdraw: 15,
      minDeposit: 5,
    },
    risk: 25000,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.BTC,
    currency: CURRENCY.BTC,
    name: 'Bitcoin',
    blockchain: BLOCKCHAIN.BITCOIN,
    metric: 100000,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/BTC.svg',
    sender: {
      address: 'bc1qdl3jcs5p3k7a0vxpn58rjeadjm4ln4wc522nnl',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.0001,
      minDeposit: 0.0001,
    },
    risk: 1,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.ETH,
    currency: CURRENCY.ETH,
    blockchain: BLOCKCHAIN.ETHEREUM,
    name: 'Ethereum',
    metric: 100000,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/ETH.svg',
    sender: {
      address: '0x0355c54ddeb4502dd8670cdaeab200d738f92c1a',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 14,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.XRP,
    currency: CURRENCY.XRP,
    name: 'Ripple',
    blockchain: BLOCKCHAIN.XRP,
    metric: 100,
    decimals: 2,
    enabled: true,
    image: 'assets/wallets/XRP.svg',
    sender: {
      address: 'rKjuXjfFsSnD2Y9vNuTY7Gd4GXCKDxPPn8',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 10000,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.LTC,
    currency: CURRENCY.LTC,
    name: 'Litcoin',
    blockchain: BLOCKCHAIN.LITECOIN,
    metric: 100000,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/LTC.svg',
    sender: {
      address: 'LfQKRHr6oJqheWKeCAvZGvxfWcCW5LtxG2',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 50,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.BNB,
    currency: CURRENCY.BNB,
    name: 'Binance smart chain',
    blockchain: BLOCKCHAIN.BINANCE_SMART_CHAIN,
    metric: 100,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/BNB.svg',
    sender: {
      address: '0x3e3304d4ce64e5947e912c9143b23f2b760f1795',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 15,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.DOGE,
    currency: CURRENCY.DOGE,
    name: 'Dogecoin',
    blockchain: BLOCKCHAIN.DOGECOIN,
    metric: 1000,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/DOGE.svg',
    sender: {
      address: 'DFZCd3RzwukTBut5WzB1puonfjpDQgoyT1',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 60000,
  },
  {
    type: WALLET_TYPE.CRYPTO,
    code: WALLET_CODE.TRX,
    currency: CURRENCY.TRX,
    name: 'Tron',
    blockchain: BLOCKCHAIN.TRON,
    metric: 100,
    decimals: 8,
    enabled: true,
    image: 'assets/wallets/TRX.svg',
    sender: {
      address: 'TH25ZjRbtgrnz9ZQuJr2J2aMsVQ5oqp6dz',
      balance: 0,
    },
    ranges: {
      minWithdraw: 0.001,
      minDeposit: 0.001,
    },
    risk: 75000,
  },
  {
    code: WALLET_CODE.USDT,
    currency: CURRENCY.USDT,
    name: 'Tether',
    type: WALLET_TYPE.TOKEN,
    blockchains: [
      {
        blockchain: BLOCKCHAIN.TRON,
        blockchain_base: BLOCKCHAIN.TRON,
        code: WALLET_CODE.TRX,
        type: TOKEN_TYPES.TRC_20,
        identifier: 'TThAxEpnuhjMFnyXFW3Pr2SJDokFXPnxsj',
        sender: {
          address: 'TH25ZjRbtgrnz9ZQuJr2J2aMsVQ5oqp6dz',
          balance: 0,
        },
      },
      {
        blockchain: BLOCKCHAIN.ETHEREUM,
        blockchain_base: BLOCKCHAIN.ETHEREUM,
        code: WALLET_CODE.ETH,
        type: TOKEN_TYPES.ERC_20,
        identifier: '0xdac17f958d2ee523a2206206994597c13d831ec7',
        sender: {
          address: '0x0355c54ddeb4502dd8670cdaeab200d738f92c1a',
          balance: 0,
        },
      },
      {
        blockchain: BLOCKCHAIN.BINANCE_SMART_CHAIN,
        blockchain_base: BLOCKCHAIN.BINANCE_SMART_CHAIN,
        code: WALLET_CODE.BNB,
        type: TOKEN_TYPES.BEP_20,
        identifier: '0x55d398326f99059fF775485246999027B3197955',
        sender: {
          address: '0x3e3304d4ce64e5947e912c9143b23f2b760f1795',
          balance: 0,
        },
      },
    ],
    metric: 100,
    decimals: 2,
    enabled: true,
    image: 'assets/wallets/USDT.svg',
    ranges: {
      minWithdraw: 25,
      minDeposit: 5,
    },
    risk: 5000,
  },
];
